import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import StoreContext from "./../../../Store/Context";

const RoutesPrivate = ({ component: Component, ...rest }) => {
  const { token, usr_type, per_std, allow } = useContext(StoreContext);
  if (!token && token === null) {
    return (
      <Route>
        <Redirect to="/login" />
      </Route>
    );
  } else {
    if (!rest.path.includes(usr_type)) {
      return <Redirect to={`${usr_type}/home`} />;
    }
    if (usr_type.replace(/\//g, "") === "parents" || usr_type.replace(/\//g, "") === "teachers") {
      if (per_std === null || per_std === undefined) {
        if (allow) {
          return <Route {...rest} render={() => token !== null && <Component {...rest} />} />;
        } else {
          return <Redirect to="/lobby" />;
        }
      } else {
        return <Route {...rest} render={() => token !== null && <Component {...rest} />} />;
      }
    } else {
      return <Route {...rest} render={() => token !== null && <Component {...rest} />} />;
    }
  }
};

export { RoutesPrivate };
